export default "__VITE_ASSET__Cj2kNi93__"